import React, { PureComponent } from "react";
import queryString from 'query-string';
import VerticalSpace from "./components/VerticalSpace";
import Grid from "@material-ui/core/Grid";
import SimpleBottomNavigation from "./components/SimpleBottomNav";
import Button from "@material-ui/core/Button";
import { Route } from "react-router-dom";
import AppConfig from "../../config/appconfig.json";

export default class NetsConfirmation extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            ref: "", appdate: "", apptime: "", paid: "", servicing: [], requestForm: null,
            METHOD_ENET_TEXT: "eNETS",
            METHOD_PAYPAL_TEXT: "Paypal",
            isHandleConfirmationFinished: false,
            isHandleConfirmationPostApptRaiseError: false,
            isHandleConfirmationInvPaymentRaiseError: false,
            isInvoicePayment: false
        };
        this.handlePostAppt = this.handlePostAppt.bind(this);
        this.handleInvoicePayment = this.handleInvoicePayment.bind(this);
    }

    componentDidMount() {
        const query = decodeURIComponent(decodeURI(this.props.location.search));
        const values = queryString.parse(query);
        const merchantTxnRef = values.merchantTxnRef;
        const netsTxnRef = values.netsTxnRef;
        const strRequestForm = sessionStorage.getItem(merchantTxnRef);
        console.log(strRequestForm);
        const request = JSON.parse(strRequestForm);
        console.log(request);
        const strIsInvoicePayment = sessionStorage.getItem('TrxInv' + merchantTxnRef);
        //console.log(strIsInvoicePayment);
        const isInvPayment = (strIsInvoicePayment === 'true');
        //console.log(isInvoicePayment);

        this.setState({
            ref: netsTxnRef, appdate: request.DateAppt, apptime: request.Slot, paid: request.Amount,
            servicing: request.Servicing, requestForm: request, isInvoicePayment: isInvPayment
        });

        if (isInvPayment)
            this.handleInvoicePayment(request);
        else
            this.handlePostAppt(netsTxnRef, request);

        sessionStorage.removeItem(merchantTxnRef);
        sessionStorage.clear();
    }

    handlePostAppt(ref, req) {
        /*
        ClientSId: "20181107IMRcfwfuT6SN"
        DateAppt: "13/02/2019"
        Servicing: Array(1)
          0:
          ServiceCategory: "Annual Contract (4 Servicing)"
          ServiceUnit: "1"
          ServicingPriceSid: "201809304R0baHi5jr3O"
        Slot: "09:00 AM to 09:30 AM"
        SystemSid: "20181107IQIbIPjmaaI2"
        Amount: "160.00"
        */
        if (req) {

            let amountFloat = parseFloat(req.Amount);
            let amountStr = amountFloat.toFixed(2).toString();

            const requestForm = {
                ClientSid: req.ClientSid,
                SystemSid: req.SystemSid,
                DateAppt: req.DateAppt,
                Slot: req.Slot,
                Servicing: req.Servicing,
                Amount: amountStr,
                PromoCode: req.PromoCode,
                PaymentMode: this.state.METHOD_ENET_TEXT,
                ReferenceNumber: ref
            };

            const request = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(requestForm)
            };
            let isPOSTApptFailed = false;
            // Call Back-End Services
            fetch(`${AppConfig.BACK_END_URL}/APIAppt/POSTAppt`, request)
                .then(response => {
                    // console.log(response);
                    if (response.ok === false) {
                        isPOSTApptFailed = true;
                    }
                    return response.json();
                })
                .then(json => {
                    if (isPOSTApptFailed) {
                        this.setState({ isHandleConfirmationFinished: true, isHandleConfirmationPostApptRaiseError: true });
                    } else {
                        const respObj = JSON.parse(json);

                        if (respObj) {
                            console.log(respObj);
                            this.setState({ isHandleConfirmationFinished: true });
                        }
                    }
                })
                .catch(() => {
                    console.log(
                        "Something went wrong when submitting appointment. Please try again."
                    );
                    this.setState({ isHandleConfirmationFinished: true, isHandleConfirmationPostApptRaiseError: true });
                });
        }
    }

    handleInvoicePayment(invoice) {
        if (invoice) {
            let isInvoicePaymentFailed = false;
            const request = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    InvoiceSid: invoice.InvoiceSid,
                    Amount: invoice.Amount,
                    PromoCode: "",
                    PaymentMode: this.state.METHOD_ENET_TEXT
                })
            };
            // Call Back-End Services
            fetch(`${AppConfig.BACK_END_URL}/APIClient/InvoicePayment`, request)
                .then(response => {
                    // console.log(response);
                    if (response.ok === false) {
                        isInvoicePaymentFailed = true;
                    }
                    return response.json();
                })
                .then(json => {
                    if (isInvoicePaymentFailed) {
                        this.setState({ isHandleConfirmationFinished: true, isHandleConfirmationInvPaymentRaiseError: true });
                    } else {
                        const respObj = JSON.parse(json);
                        if (respObj) {
                            console.log(respObj);
                            this.setState({ isHandleConfirmationFinished: true });
                        }
                    }
                })
                .catch(() => {
                    console.log(
                        "Something went wrong when submitting invoice payment. Please try again."
                    );
                    this.setState({ isHandleConfirmationFinished: true, isHandleConfirmationInvPaymentRaiseError: true });
                });
        }
    }

    render() {
        const ConfirmButton = props => (
            <Route
                render={({ history }) => (
                    <div>
                        <Button
                            variant="outlined"
                            style={{ width: "100%" }}
                            onClick={() => {
                                history.push({
                                    pathname: "/"
                                    // ,
                                    // state: { airconsaved: true }
                                });
                            }}
                        >
                            Proceed
            </Button>
                    </div>
                )}
            />
        );

        return (
            <div>
                <div className="account">
                    <div className="account__wrapper">
                        {this.state.isHandleConfirmationFinished ? (
                            <div className="account__card">
                                <VerticalSpace />
                                <div className="card__title">
                                    <center>
                                        {this.state.isInvoicePayment ? (
                                            <h4 className="bold-text">Appointment</h4>
                                        ) : (
                                                <h4 className="bold-text">Payment</h4>
                                            )}
                                    </center>
                                    <br />
                                </div>
                                <form className="form form--horizontal">
                                    <div className="form__form-group">
                                        <p>
                                            {this.state.isInvoicePayment ? (
                                                <b>Invoice payment created successfully.</b>
                                            ) : (
                                                    <b>Payment Successfully Completed</b>
                                                )}
                                        </p>
                                    </div>
                                    <div className="form__form-group">
                                        {this.state.isInvoicePayment ? (<p></p>) : (
                                            <p>Appt Date: {this.state.appdate} - {this.state.apptime}
                                            </p>
                                        )}
                                    </div>

                                    <div className="form__form-group">
                                        {this.state.isInvoicePayment ? (<div></div>) : (
                                            <div>
                                                {
                                                    this.state.servicing ? (
                                                        <div>
                                                            <p>Type:</p>
                                                            <ol>
                                                                {this.state.servicing.map(svc => (
                                                                    <li key={svc.ServicingPriceSid}>{svc.ServiceCategory} for {svc.ServiceUnit} Fancoil(s)</li>
                                                                ))}
                                                            </ol>
                                                        </div>
                                                    ) : (<div></div>)
                                                }
                                            </div>
                                        )}
                                    </div>

                                    <div className="form__form-group">
                                        <p>Amount Paid: S$ {this.state.paid}</p>
                                    </div>
                                    <div className="form__form-group">
                                        <p>Receipt: {this.state.ref}</p>
                                    </div>
                                    <div className="form__form-group">
                                        <Grid container spacing={24}>
                                            <Grid item xs={3} />
                                            <Grid item xs={6}>
                                                {!this.state.isHandleConfirmationFinished ? (<span><b>Please wait... Do not refresh page... </b></span>) : (
                                                    <div>
                                                        {this.state.isHandleConfirmationPostApptRaiseError ? (
                                                            <span>Something went wrong when submitting appointment. Please contact our support.<br /></span>) : (<span></span>)}
                                                        {this.state.isHandleConfirmationInvPaymentRaiseError ? (
                                                            <span>Something went wrong when submitting invoice payment. Please contact our support.<br /></span>) : (<span></span>)}
                                                        <ConfirmButton />
                                                    </div>)}
                                            </Grid>
                                            <Grid item xs={3} />
                                        </Grid>
                                        <VerticalSpace />
                                    </div>
                                </form>
                                <SimpleBottomNavigation value={1} />
                            </div>
                        ) : (<div></div>)}
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/main/NetsConfirmation.js